module.exports = __webpack_public_path__ + "img/main-boardroom-pizza.377711f5.jpg";